module.exports = __webpack_public_path__ + "d1bb026072251a8552b1e20afef1f923.jpg";